import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (values?.dynamicItemName) {
    let dynamicItemNameError = []
    if (values?.dynamicItemName?.map((item, index) => {
      const dynamicNameError = {}
      if (!item?.itemName || item?.itemName.toString().trim() === '') {
        dynamicNameError.itemName = messages.required;
        dynamicItemNameError[index] = dynamicNameError;
      } else if (item?.itemName?.length > inputTextLimit) {
        dynamicNameError.itemName = messages.inputTextLimitError;
        dynamicItemNameError[index] = dynamicNameError;
      }

      if (!item?.otherItemName || item?.otherItemName.toString().trim() === '') {
        dynamicNameError.otherItemName = messages.required;
        dynamicItemNameError[index] = dynamicNameError;
      } else if (item?.otherItemName?.length > inputTextLimit) {
        dynamicNameError.otherItemName = messages.inputTextLimitError;
        dynamicItemNameError[index] = dynamicNameError;
      }

      if (!item?.language || item?.language.toString().trim() === '') {
        dynamicNameError.language = messages.required;
        dynamicItemNameError[index] = dynamicNameError;
      }
    }));
    if (dynamicItemNameError?.length > 0) errors.dynamicItemName = dynamicItemNameError;
  }
  if (values.startValue != 0 && values.startValue < 0) {
    if (Number(values.startValue) || Number(values.startValue) != parseInt(values.startValue, 10)) {
      errors.startValue = messages.startValueIsInvalid;
    }
  }

  if (!Number(values.endValue) || Number(values.endValue) != parseInt(values.endValue, 10)) {
    errors.endValue = messages.endValueIsInvalid;
  }

  if (Number(values.endValue) < Number(values.startValue)) {
    errors.endValue = messages.endValueGreater;
  }

  if (!values.makeType) {
    errors.makeType = messages.required;
  }


  return errors
}

export default validate